import { faThermometerQuarter } from '@fortawesome/free-solid-svg-icons'
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    reservation : {},
    person: {
      nbrAdulte : 1 ,
      nbrChildren : 0,
      nbrRoom : 1
    },
    anounceReserved : {}
}

export const reservationHebergSlice = createSlice({
  name: 'reservationHeberg',
  initialState,
  reducers: {

    reservation: (state,action) => {
      state.reservation = action.payload
    },
    changeNbrPersonHb :  (state,action) => {
      state.person = action.payload
    },
    addDataAnnounce :  (state,action) => {
      state.anounceReserved = action.payload
    },
  },
})


export const { reservation ,changeNbrPersonHb,addDataAnnounce} = reservationHebergSlice.actions

export default reservationHebergSlice.reducer